var map = {
	"./Info/arrow-up-right.svg": 91039,
	"./Info/default-avatar.svg": 66926,
	"./Info/nav-courses.svg": 82685,
	"./add-image.svg": 51159,
	"./alert-triangle.svg": 30285,
	"./arrow-left.svg": 39845,
	"./arrow-right.svg": 91720,
	"./arrow-up-right.svg": 89828,
	"./avatar.svg": 22669,
	"./book.svg": 58049,
	"./check-blue.svg": 12547,
	"./check-error.svg": 15303,
	"./check-green.svg": 53800,
	"./check-square.svg": 79990,
	"./check.svg": 53658,
	"./chevron-down.svg": 66688,
	"./chevrons-down.svg": 45595,
	"./chevrons-up.svg": 25876,
	"./circle.svg": 57042,
	"./clipboard-black.svg": 65778,
	"./clipboard.svg": 17848,
	"./clock.svg": 95904,
	"./copy.svg": 73761,
	"./default-logo.svg": 92583,
	"./download.svg": 59474,
	"./drag.svg": 21403,
	"./edit-pen.svg": 22040,
	"./edit.svg": 23374,
	"./editing-round.svg": 11333,
	"./educationMaterials/additionalAudio.svg": 41968,
	"./educationMaterials/additionalImage.svg": 83193,
	"./educationMaterials/additionalText.svg": 16351,
	"./educationMaterials/additionalVideo.svg": 16991,
	"./educationMaterials/audio.svg": 89649,
	"./educationMaterials/audioActive.svg": 37559,
	"./educationMaterials/audioSuccess.png": 40400,
	"./educationMaterials/closed.svg": 93945,
	"./educationMaterials/closedSimple.svg": 39027,
	"./educationMaterials/exam.svg": 89892,
	"./educationMaterials/examActive.svg": 1506,
	"./educationMaterials/examGray.svg": 37769,
	"./educationMaterials/examSimple.svg": 8930,
	"./educationMaterials/examSimpleGreen.svg": 35115,
	"./educationMaterials/examSuccess.svg": 80445,
	"./educationMaterials/examUnsuccess.svg": 40902,
	"./educationMaterials/pdf.svg": 68877,
	"./educationMaterials/pdfActive.svg": 35163,
	"./educationMaterials/pdfSuccess.svg": 79550,
	"./educationMaterials/practice.svg": 24906,
	"./educationMaterials/practiceActive.svg": 13960,
	"./educationMaterials/practiceGray.svg": 89647,
	"./educationMaterials/practiceSimple.svg": 31252,
	"./educationMaterials/practiceSimpleGreen.svg": 98253,
	"./educationMaterials/practiceSuccess.svg": 34851,
	"./educationMaterials/practiceUnsuccess.svg": 60184,
	"./educationMaterials/presentation.svg": 80925,
	"./educationMaterials/presentationActive.svg": 43723,
	"./educationMaterials/presentationSuccess.svg": 85006,
	"./educationMaterials/theory.svg": 12398,
	"./educationMaterials/theoryActive.svg": 59444,
	"./educationMaterials/theoryGray.svg": 67851,
	"./educationMaterials/theorySimple.svg": 67296,
	"./educationMaterials/theorySimpleGreen.svg": 32241,
	"./educationMaterials/theorySuccess.svg": 79855,
	"./educationMaterials/video.svg": 10806,
	"./educationMaterials/videoActive.svg": 45356,
	"./educationMaterials/videoSimple.svg": 20536,
	"./educationMaterials/videoSimpleGreen.svg": 92521,
	"./educationMaterials/videoSuccess.svg": 71847,
	"./eye-off.svg": 12761,
	"./eye.svg": 61589,
	"./facebook.svg": 52542,
	"./file-text.svg": 63048,
	"./filters-line.svg": 37778,
	"./filters.svg": 28155,
	"./google.svg": 15583,
	"./hint.svg": 99977,
	"./history-restore.svg": 91007,
	"./image.svg": 12225,
	"./list.svg": 50710,
	"./log-out.svg": 62007,
	"./magnify.svg": 5611,
	"./nav-company-profile.svg": 99103,
	"./nav-courses.svg": 81368,
	"./nav-create-company.svg": 80532,
	"./nav-edit.svg": 24966,
	"./nav-edu-programs.svg": 23564,
	"./nav-groups.svg": 86634,
	"./nav-history.svg": 30906,
	"./nav-home.svg": 80467,
	"./nav-language.svg": 67572,
	"./nav-library.svg": 77123,
	"./nav-settings.svg": 30241,
	"./nav-support.svg": 64671,
	"./nav-technicalSupport.svg": 79540,
	"./nav-users.svg": 38378,
	"./nav/admin.svg": 54181,
	"./nav/log-out.svg": 39477,
	"./nav/manager.svg": 33373,
	"./nav/owner.svg": 96517,
	"./nav/profile.svg": 59375,
	"./nav/student.svg": 40849,
	"./nav/trainer.svg": 80783,
	"./notify/alert-triangle.svg": 77423,
	"./notify/checked.svg": 18847,
	"./notify/email.svg": 48980,
	"./notify/error.svg": 99110,
	"./notify/file.svg": 61606,
	"./notify/key.svg": 11305,
	"./notify/lock.svg": 2449,
	"./notify/success.svg": 28197,
	"./notify/trash.svg": 34866,
	"./notify/unlock.svg": 32728,
	"./notify/upload-cloud.svg": 54427,
	"./notify/warning-circle.svg": 84125,
	"./notify/warning-outline.svg": 68097,
	"./notify/warning.svg": 14192,
	"./openbook.svg": 88641,
	"./passage-alert-octagon.svg": 46593,
	"./passage-check-square.svg": 61827,
	"./passage-clock.svg": 68059,
	"./passage-edit.svg": 3775,
	"./percent.svg": 6261,
	"./plus-circle.svg": 49611,
	"./plus.svg": 68718,
	"./programMaterials/closed.svg": 85783,
	"./programMaterials/course.svg": 86560,
	"./programMaterials/courseActive.svg": 65222,
	"./programMaterials/courseSuccess.svg": 61505,
	"./programMaterials/webinar.svg": 20515,
	"./programMaterials/webinarActive.svg": 63337,
	"./programMaterials/webinarSuccess.svg": 37276,
	"./select-cards.svg": 57296,
	"./select.svg": 66162,
	"./shuffle.svg": 77669,
	"./square.svg": 31927,
	"./table-blocked.svg": 28969,
	"./table-certificate.svg": 65848,
	"./table-delete-user.svg": 2934,
	"./table-edit-user.svg": 43053,
	"./table-reassign.svg": 54931,
	"./table-send-email-user.svg": 57726,
	"./table-shield.svg": 20088,
	"./table-unblocked.svg": 64930,
	"./table-view.svg": 89152,
	"./table-viewUser.svg": 63009,
	"./test-failed.svg": 86752,
	"./test-success.svg": 35940,
	"./trash-blue.svg": 82925,
	"./trash-gray.svg": 9296,
	"./trash.svg": 78196,
	"./upload-white.svg": 82549,
	"./upload.svg": 51873,
	"./user-plus.svg": 20612,
	"./users.svg": 10290,
	"./webinar-green.svg": 45706,
	"./webinar-silver.svg": 7642,
	"./webinar-yellow.svg": 99473
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16400;